<template>
  <div class="topmunu">
    <div class="left">
      <img src="../assets/login/hylogo.png" />
      <p>考生服务系统</p>
    </div>
    <!-- <div class="center">
      <ul>
        <li @click="jumpI" :class="{ active: isactive == 0 }">首页</li>
        <li @click="jumpE" :class="{ active: isactive == 1 }">报名</li>
        <li @click="jumpA" :class="{ active: isactive == 2 }">查成绩</li>
      </ul>
    </div> -->
    <div class="right">
      <div>
        你好,{{ this.$store.state.userInfo.name }}
        {{ "<" + this.$store.state.userInfo.id + ">" }}
      </div>
      <div @click="logout">退出登录</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isactive: 0,
    };
  },
  watch: {
    $route(to, from) {
      // console.log(to.path);
      if (to.path == "/enroll") {
        this.isactive = 1;
      } else if (to.path == "/achievement") {
        this.isactive = 2;
      } else if (to.path == "/index") {
        this.isactive = 0;
      }
    },
  },
  methods: {
    jumpI() {
      this.$router.push("/index");
      this.isactive = 1;
    },
    jumpE() {
      this.$router.push("/enroll");
      this.isactive = 1;
    },
    jumpA() {
      this.$router.push("/achievement");
      this.isactive = 2;
    },
    logout() {
      sessionStorage.clear();
      this.$router.push("/");
      this.$allMethods.returnSuccess("success", "退出登录");
    },
  },
  mounted() {
    // console.log(this.$store.state.userInfo.id);
    if (this.$route.path == "/enroll") {
      this.isactive = 1;
    } else if (this.$route.path == "/achievement") {
      this.isactive = 2;
    } else if (this.$route.path == "/index") {
      this.isactive = 0;
    }
  },
};
</script>
<style scoped>
.topmunu {
  width: 100%;
  height: 80px;
  border-bottom: 1px solid #f1f1f1;
  background: white;
  padding: 10px 0;
}
.left {
  float: left;
  padding-left: 20px;
}
.left img {
  height: 60px;
  width: auto;
}
.left p {
  display: inline-block;
  position: relative;
  left: 40px;
  top: -20px;
  font-size: 22px;
  font-weight: 700;
}
.center {
  float: left;
  position: relative;
  left: 24%;
  top: -10px;
}
ul li {
  list-style: none;
  padding: 28px 40px;
  /* margin: auto; */
  /* border-bottom: 1px solid #f1f1f1; */
  cursor: pointer;
  /* display: inline-block; */
  float: left;
  font-size: 20px;
}
li:hover {
  background: #f7f7f7;
}
ul {
  padding: 0px;
  margin: 0px;
  text-align: center;
}
.title {
  color: #2d76f9;
  font-weight: 600;
}
.active {
  /* background: #f9f9f9; */
  color: #2d76f9;
  border-bottom: 2px solid #2d76f9;
}
.right {
  float: right;
  line-height: 70px;
  font-size: 14px;
  min-width: 500px;
}
.right div {
  margin: 0px 20px;
  float: left;
}

.right div:nth-child(2):hover {
  cursor: pointer;
  color: #2d76f9;
}
</style>